import { useGameContext } from '@/state/GameContext';
import { ItemIcon } from './ItemIcon';

export function InventoryPanel() {
  const game = useGameContext();
  const entries = Object.entries(game.inventory).filter(([, n]) => n > 0);

  return (
    <div className="panel-body">
      <div className="muted" style={{ marginBottom: 8 }}>{entries.length} collected item type(s)</div>
      {entries.length === 0 ? (
        <div className="muted">Collect crafted results by clicking the result slot.</div>
      ) : (
        <div className="browser-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, 44px)' }}>
          {entries.map(([id, count]) => {
            return (
              <ItemIcon
                key={id}
                itemId={id}
                size={44}
                count={count}
                favorite={game.favorites.includes(id)}
                draggable
                onClick={() => game.placeItemAnySlot(id)}
              />
            );
          })}
        </div>
      )}
      <div className="row" style={{ marginTop: 12 }}>
        <button className="btn danger" onClick={() => { if (confirm('Clear collected inventory?')) game.clearInventory(); }}>
          Clear collected
        </button>
      </div>
      {entries.length > 0 ? <div className="muted" style={{ marginTop: 8 }}>Drag collected items back into the grid to combine them.</div> : null}
    </div>
  );
}
